import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'

import { optIntroductionServiceOrderApi } from '@services/api/optIntroductionServiceOrderApi'

const initOPTIntroductionVideoServiceOrderDetail: TOPTIntroductionVideoService.TState['introductionVideoOrderDetail'] = {
  data: {
    id: '',
    orderNumber: '',
    storeId: '',
    storeName: '',
    storeCD: '',
    storeManagerId: '',
    personInChargeName: '',
    email: '',
    shootingService: false,
    performerTitleAndName: '',
    introductionVideoUrl: '',
    introductionVideoDownloadUrl: '',
    cookingText1: '',
    cookingVideo1Url: '',
    cookingVideo1DownloadUrl: '',
    cookingVideoSupplement1Url: '',
    cookingVideoSupplement1DownloadUrl: '',
    cookingText2: '',
    cookingVideo2Url: '',
    cookingVideo2DownloadUrl: '',
    cookingVideoSupplement2Url: '',
    cookingVideoSupplement2DownloadUrl: '',
    storeAppearanceSupplementUrl: '',
    storeAppearanceSupplementDownloadUrl: '',
    shimeCommentVideoUrl: '',
    shimeCommentVideoDownloadUrl: '',
    supplementaryVideoComment: '',
    status: 0,
    type: ''
  }
}

const initOPTIntroductionServiceOrderListData: TOPTIntroductionVideoService.TState['optIntroductionVideoServiceOrderList'] = {
  data: [],
  pageIndex: 1,
  pageSize: 20,
  totalRecords: 0,
  totalPage: 1,
  hasNextPage: false,
  hasPreviousPage: false
}

const initialState: TOPTIntroductionVideoService.TState = ({
  optIntroductionVideoServiceOrderList: initOPTIntroductionServiceOrderListData,
  isfetchingOrders: false,
  introductionVideoOrderDetail: initOPTIntroductionVideoServiceOrderDetail,
  isLoading: false,
  showVideos: false,
  filter: {
    term: '',
    fromDate: null,
    toDate: null,
    status: null,
    PageSize: 20,
    PageIndex: 1
  }
})

export const fetchOPTIntroductionVideoServiceOrderList = createAsyncThunk(
  'optIntroductionVideoServiceOrder/fetchList',
  async (params: TOPTIntroductionVideoService.FetchList, { rejectWithValue }) => {
    try {
      const response = await optIntroductionServiceOrderApi.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchSingle = createAsyncThunk(
  'optIntroductionVideoServiceOrder/fetchSingle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await optIntroductionServiceOrderApi.fetchSingle(id)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const saveChangeStatus = createAsyncThunk(
  'optIntroductionVideoServiceOrder/saveChangeStatus',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await optIntroductionServiceOrderApi.saveChangeStatus(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

const optIntroductionVideoServiceOrderSlice = createSlice({
  name: 'optIntroductionVideoServiceOrder',
  initialState,
  reducers: {
    setLoading (state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    setShowVideos (state) {
      state.showVideos = !state.showVideos
    },
    changeDetailStatus (state, action) {
      state.introductionVideoOrderDetail.data.status = action.payload
    },
    changeSearchTerm (state, action) {
      state.filter.term = action.payload
    },
    changeSearchFromDate (state, action) {
      state.filter.fromDate = action.payload
    },
    changeSearchToDate (state, action) {
      state.filter.toDate = action.payload
    },
    changeSearchStatus (state, action) {
      state.filter.status = action.payload
    },
    changeSearchPageIndex (state, action) {
      state.filter.PageIndex = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchOPTIntroductionVideoServiceOrderList.fulfilled, (state, action: PayloadAction<TOPTIntroductionVideoService.TState['optIntroductionVideoServiceOrderList']>) => {
        if (!action.payload) return
        state.optIntroductionVideoServiceOrderList = action.payload
        if (!state.optIntroductionVideoServiceOrderList.data?.length) {
          state.optIntroductionVideoServiceOrderList = action.payload
        }
        state.isfetchingOrders = false
      })
      .addCase(fetchSingle.fulfilled, (state, action: PayloadAction<TOPTIntroductionVideoService.TState['introductionVideoOrderDetail']>) => {
        state.isLoading = false
        if (!action.payload?.data) return
        state.introductionVideoOrderDetail.data = action.payload.data
      })
      .addCase(fetchSingle.pending, state => {
        state.isLoading = true
      })
  }
})

export const {
  setLoading,
  setShowVideos,
  changeDetailStatus,
  changeSearchStatus,
  changeSearchToDate,
  changeSearchFromDate,
  changeSearchTerm,
  changeSearchPageIndex
} = optIntroductionVideoServiceOrderSlice.actions

export const optIntroductionVideoServiceOrderReducer = optIntroductionVideoServiceOrderSlice.reducer
export default optIntroductionVideoServiceOrderSlice.reducer
